import { render } from "./404.vue?vue&type=template&id=3d86c14e&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=3d86c14e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d86c14e"

export default script